"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("@prosay/common");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_better_parsed_text_1 = __importDefault(require("react-native-better-parsed-text"));
const react_native_paper_1 = require("react-native-paper");
const DateFromNow_1 = require("./DateFromNow");
// TODO: Figure out where to put this styling information
const chat = {
    me: {
        background: "lightblue",
        color: "black",
    },
    other: {
        background: "lightgrey",
        color: "black",
    },
};
const styles = react_native_1.StyleSheet.create({
    chatBubble: {
        borderRadius: 25,
        flexGrow: 0,
        flexShrink: 1,
        padding: 15,
        paddingHorizontal: 20,
    },
    chatBubbleFromMe: {
        backgroundColor: chat.me.background,
        borderBottomRightRadius: 5,
        paddingBottom: 30,
        paddingTop: 15,
    },
    chatBubbleFromOther: {
        backgroundColor: chat.other.background,
        borderBottomLeftRadius: 5,
    },
    chatBubbleText: {},
    chatBubbleTextFromMe: {
        color: chat.me.color,
    },
    chatBubbleTextFromOther: {
        color: chat.other.color,
    },
    checkmark: {
        backgroundColor: "white",
        bottom: 0,
        position: "absolute",
        right: 0,
    },
    container: {
        // maxWidth: 500,
        justifyContent: "flex-start",
        marginBottom: 10,
        marginHorizontal: 5,
    },
    containerFromMe: {
        flexDirection: "row-reverse",
    },
    containerFromOther: {
        flexDirection: "row",
    },
    dateContainer: {
        alignSelf: "center",
        flexGrow: 0,
        flexShrink: 0,
    },
    dateContainerFromMe: {
    // alignSelf: "flex-start"
    },
    dateContainerFromOther: {
    // alignSelf: "flex-end"
    },
    dateText: {
        fontSize: 10,
        marginHorizontal: 5,
    },
    highlightedChatBubble: {
        backgroundColor: "rgba(0, 0, 0, .1)",
    },
    link: {
        color: "blue",
        textDecorationLine: "underline",
    },
});
exports.Checkmark = ({ status }) => {
    const [icon, color] = react_1.useMemo(() => {
        switch (status.type) {
            case "sending":
                return ["checkbox-marked-circle-outline", "grey"];
            case "sent":
                return ["checkbox-marked-circle-outline", "rgb(127, 163, 175)"];
            case "read":
                return [
                    "checkbox-multiple-marked-circle-outline",
                    "rgb(127, 163, 175)",
                ];
            default:
                common_1.unreachable();
        }
    }, [status]);
    return (react_1.default.createElement(react_native_paper_1.IconButton, { style: [styles.checkmark, { backgroundColor: color }], color: "white", size: 12, icon: icon }));
};
const handleUrlPress = (url) => react_native_1.Linking.openURL(`${url}`);
const handlePhonePress = (phone) => react_native_1.Linking.openURL(`tel:${phone}`);
const handleEmailPress = (email) => react_native_1.Linking.openURL(`mailto:${email}`);
const onPressDoNothing = () => { };
exports.ChatBubbleContents = ({ content, highlight, isMe, onPress = onPressDoNothing, onLongPress, containerStyle, textStyle, status, }) => {
    const isMeStyle = react_1.useMemo(() => (isMe ? styles.chatBubbleFromMe : styles.chatBubbleFromOther), [isMe]);
    const chatBubbleIsMeStyle = react_1.useMemo(() => isMe ? styles.chatBubbleTextFromMe : styles.chatBubbleTextFromOther, [isMe]);
    const highlightStyle = react_1.useMemo(() => highlight && styles.highlightedChatBubble, [highlight]);
    return (react_1.default.createElement(react_native_paper_1.TouchableRipple, Object.assign({ borderless: true, rippleColor: "rgba(0, 0, 0, .32)", style: [
            styles.chatBubble,
            isMeStyle,
            highlightStyle,
            containerStyle,
        ] }, { onLongPress, onPress }),
        react_1.default.createElement(react_1.default.Fragment, null,
            typeof content === "string" ? (react_1.default.createElement(react_native_better_parsed_text_1.default, { parse: [
                    {
                        onPress: handleUrlPress,
                        style: styles.link,
                        type: "url",
                    },
                    {
                        onPress: handlePhonePress,
                        style: styles.link,
                        type: "phone",
                    },
                    {
                        onPress: handleEmailPress,
                        style: styles.link,
                        type: "email",
                    },
                ], style: [
                    styles.chatBubbleText,
                    chatBubbleIsMeStyle,
                    textStyle,
                ] }, content)) : (content),
            status && react_1.default.createElement(exports.Checkmark, { status: status }))));
};
exports.ChatBubble = ({ children, containerStyle, contentsStyle, date, highlight, isMe, onLongPress, onPress, status, textStyle, }) => {
    const containerIsMeStyle = react_1.useMemo(() => (isMe ? styles.containerFromMe : styles.containerFromOther), [isMe]);
    return (react_1.default.createElement(react_native_1.View, { style: [styles.container, containerStyle, containerIsMeStyle] },
        react_1.default.createElement(exports.ChatBubbleContents, Object.assign({}, {
            containerStyle: contentsStyle,
            content: children,
            date,
            highlight,
            isMe,
            onLongPress,
            onPress,
            status,
            textStyle,
        })),
        react_1.default.createElement(react_native_1.View, { style: [
                styles.dateContainer,
                isMe
                    ? styles.dateContainerFromMe
                    : styles.dateContainerFromOther,
            ] },
            react_1.default.createElement(DateFromNow_1.DateFromNow, { date: date, style: styles.dateText }))));
};
//# sourceMappingURL=data:application/json;base64,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